import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Drawer, Badge } from "antd";
import { useStores } from "@/store";
import qs from "qs";
import {
  MapView,
  Restaurant,
  Button,
  Header,
  Locate,
  Footer,
} from "@/components";
import { getQuery } from "@/service/http";
import {
  Banner,
  Profile,
  Review,
  Aside,
  Menu,
  Detail,
  Grid,
} from "./components";
import { Similar } from "../restaurant/components";
import "./index.less";
import GetDeal from "./components/getDeal";
import WalkIn from "@/components/buy-deal";
import Redeem from "./components/redeem";
import { goLogin } from "@/service/utils";

const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|ArkWeb/i.test(
    navigator.userAgent
  );

/**
 * 优惠预订页面
 *
 */
const Main = () => {
  const { t } = useTranslation();
  const { dealStore, voucherStore } = useStores();
  const { dealId } = useParams();
  const [info, setInfo] = useState(null);
  const [visible, setVisible] = useState(false);
  const [getDealVisible, setGetDealVisible] = useState(false);
  const [showWalkIn, setShowWalkIn] = useState(false);
  const [voucherAvailableList, setVoucherAvailableList] = useState([]);
  const [recommenders, setRecommenders] = useState([]);
  const [redeemVisible, setRedeemVisible] = useState(false);
  let {
    payment: payState1,
    lang = "en",
    region = "shanghai",
    private_token,
  } = getQuery();
  document.body.classList.add("is-deal");
  payState1 = payState1 === "undefined" ? "" : payState1;
  const payCallbackParams = qs.parse(payState1 || "", { delimiter: "-" });
  useEffect(() => {
    dealStore.show(dealId).then((res) => {
      if (res?.deal?.is_need_login && !private_token) {
        return goLogin();
      }
      setInfo(res);
      voucherStore.getVoucherAvailableList(dealId).then((vouchers) => {
        const filterData = vouchers.filter((_) => _?.applicable);
        setVoucherAvailableList(filterData);
        if (payState1 && !payCallbackParams.order_id && res?.deal?.can_buy_voucher) {
          setGetDealVisible(true);
        }
        sessionStorage.setItem(`v-${dealId}`, filterData.length);
      });
    });
    if (payCallbackParams.private_token) {
      window.private_token = payCallbackParams.private_token;
    }
    if (payCallbackParams.order_id) {
      walkIn();
    }
    dealStore.getRecommenders(dealId).then(setRecommenders);
  }, [dealId, dealStore, payState1, voucherStore]);

  const canWalkIn = useMemo(() => {
    return info?.deal?.use_type === 'walk_in' && info?.deal?.inventory > 0;
  }, [info]);

  const enable_pre_pay = useMemo(() => {
    return info?.deal?.enable_pre_pay
  }, [info]);

  // 为防止出现在其他端已经兑换的情况 再次查询列表进行校验
  const checkRedeem = (flag = false) => {
    voucherStore.getVoucherAvailableList(dealId).then((res) => {
      const filterData = res.filter((_) => _?.applicable);
      setVoucherAvailableList(filterData);
      // payCallbackParams.order_id存在，表明是walkin返回，不应该触发这里的逻辑
      if (flag && !payCallbackParams.order_id) {
        setRedeemVisible(true);
      }
    });
  };

  function bookNow() {
    window.location.href = dealStore.webform;
  }

  function getDeal() {
    if (private_token) {
      setGetDealVisible(true);
    } else {
      goLogin();
    }
  }

  function walkIn() {
    if (private_token) {
      setShowWalkIn(true);
    } else {
      goLogin();
    }
  }

  function getUrl(name) {
    try {
      let reg = new RegExp("[^?&]?" + encodeURI(name) + "=[^&]+");
      // let arr = parent.document.getElementById("reservation_webform").contentWindow.location.href.match(reg);
      let parentUrl = getParentUrl();
      let arr = parentUrl.toString().match(reg);
      //let arr =  "https://staging-website.diningcity.asia/#/deal/8531?lang=en&login_url=http%3A%2F%2Flogin.diningcitydeals.com%2Fmembers%2Fsign_in%3Flocale%3Den&private_token=&callback=http%3A%2F%2Fwww.diningcitydeals.com%2Fen%2Fdiningcity%2Fdeals%2F8531%2Freservation&payment=".match(reg);
      if (arr != null) {
        return decodeURIComponent(arr[0].substring(arr[0].search("=") + 1));
      } else {
        return "";
      }
    } catch (e) {
      console.log(e);
      return "";
    }
  }

  function getParentUrl() {
    let url = "";
    if (parent !== window) {
      try {
        url = parent.location.href;
      } catch (e) {
        url = document.URL;
      }
    }
    return url;
  }

  const WalkInBtn = () => { 
    const { enable_pre_pay, inventory } = info?.deal || {}
    switch (true) {
      case enable_pre_pay && inventory > 0: // 允许预定，并且剩余库存 > 0
        return <Button type="primary" onClick={walkIn}>{t("walkin.Buy now")}</Button>
        break;
      case enable_pre_pay && inventory === 0:   // 允许预定，并且剩余库存 == 0
        return <Button type="disabled">{t("walkin.SoldOut")}</Button>
        break;
      case !enable_pre_pay && inventory > 0:   // 不允许预定，并且剩余库存 > 0
        return <Button type="primary" onClick={walkIn}>{t("walkin.Claim now")}</Button>
        break;
      case !enable_pre_pay && inventory === 0:   // 不允许预定，并且剩余库存 == 0
        return <Button type="disabled">{t("walkin.Fully claimed")}</Button>
        break;
      default:
        return null
        break;
    }
  };

  const deal = info?.deal;
  const restaurant = deal?.restaurant;
  const isWalkInDeal = deal?.use_type === "walk_in";
  const isRedeemOnlyReservation = restaurant?.reservation_type === 4;
  const isBookableReservation = !!restaurant && restaurant.reservation_type !== 4;
  const canBuyVoucher = !!deal?.can_buy_voucher;
  const hasVoucherRedeemAction =
    canBuyVoucher && isRedeemOnlyReservation && private_token;
  const hasVoucherBookingAction =
    canBuyVoucher && isBookableReservation && private_token;
  const hasNormalBookingAction =
    isBookableReservation && restaurant?.booking_enabled;
  const hasDesktopFooterAction =
    isWalkInDeal || (canBuyVoucher && isBookableReservation);

  const renderGetDealButton = () => (
    <Button
      type="primary"
      onClick={() => getDeal()}
      className={"getDealClass"}
    >
      {t("WEB.Get deal1")}
    </Button>
  );

  const renderRedeemButton = () => (
    <Badge count={voucherAvailableList.length} offset={[-10, 5]}>
      <Button
        type="primary"
        onClick={() => setRedeemVisible(true)}
        className={"getDealClass"}
        disabled={voucherAvailableList.length === 0}
      >
        {t("VOUCHERS.Redeem")}
      </Button>
    </Badge>
  );

  const renderBookNowButton = () => {
    if (hasVoucherBookingAction) {
      return (
        <Button
          type="primary"
          onClick={bookNow}
          disabled={
            !canBuyVoucher ||
            !voucherAvailableList ||
            voucherAvailableList.length == 0
          }
        >
          {voucherAvailableList.length > 0 ? (
            <i className="badge small">{voucherAvailableList.length}</i>
          ) : null}
          {t("WEB.Book now")}
        </Button>
      );
    }

    if (hasNormalBookingAction) {
      return (
        <Button type="primary" onClick={bookNow}>
          {t("WEB.Book now")}
        </Button>
      );
    }

    return null;
  };

  const renderPrimaryAction = () => {
    if (isWalkInDeal) {
      return <WalkInBtn></WalkInBtn>;
    }

    if (hasVoucherRedeemAction) {
      return <div className="page-deal-voucher">{renderRedeemButton()}</div>;
    }

    return renderBookNowButton();
  };

  const renderDesktopPrimaryAction = () => {
    if (isWalkInDeal) {
      return <WalkInBtn></WalkInBtn>;
    }

    if (hasVoucherRedeemAction) {
      return <div className="page-deal-voucher">{renderRedeemButton()}</div>;
    }

    return null;
  };

  const FootOverlayBtn = () => {
    return (
      <div className={"bookNowClass mobileBookNowClass"}>
        {renderPrimaryAction()}
      </div>
    );
  };

  const DesktopOverlayBtn = () => {
    return (
      <div className={"bookNowClass desktopBookNowClass"}>
        {renderDesktopPrimaryAction()}
      </div>
    );
  };

  return (
    <div className="hasFooterContent">
      <div className="page-deal">
        <section className="page-deal--main">
          {!info ? null : (
            <React.Fragment>
              {info.photos.length ? (
                <Banner {...info.deal} photos={info.photos} />
              ) : null}
              {info.photos.length ? <Grid photos={info.photos} /> : null}
              <Profile {...info.deal} />
              {info.menus.length ? (
                <Menu menus={info.menus} deal_price={info.deal.deal_price} />
              ) : null}
              {info.reviews.length ? (
                <Review
                  {...info.deal}
                  reviews={info.reviews}
                  deal={info.deal}
                />
              ) : null}
              <Detail
                {...info.deal}
                deal={info.deal}
                availabilities={info.availabilities}
              />
              {info.deal.term_condition && info.deal.term_condition != "" ? (
                <h3 style={{ fontSize: 15, marginBottom: 10, marginTop: 0 }}>
                  {t("WEB.Terms and conditions")}
                </h3>
              ) : null}
              {info.deal.term_condition && info.deal.term_condition != "" ? (
                <div
                  style={{
                    fontSize: 13,
                    textAlign: "left",
                    marginBottom: "10px",
                    wordBreak: "break-word",
                    whiteSpace: "pre-line",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: info.deal.term_condition.replace("\n\n", "<br/>"),
                  }}
                ></div>
              ) : null}
              {info.deal.term_condition && info.deal.term_condition != "" ? (
                <div className="hairline-bottom-new"></div>
              ) : null}
              <h3 style={{ paddingTop: "10px" }}>
                {t("WEB.Restaurant introduction")}
              </h3>
              <div className="restaurant-info">
                <MapView {...info.deal.restaurant} />
                <Restaurant restaurant={info.deal.restaurant} only={true} />
              </div>
              {recommenders.length > 0 && (
                <div style={{ paddingBottom: "50px" }}>
                  <Similar recommenders={recommenders} type="deal" />
                </div>
              )}
              <div
                className={`page-footer ${
                  hasDesktopFooterAction ? "not-hidden" : ""
                }`}
                align="right"
              >
                {canBuyVoucher && renderGetDealButton()}
                &nbsp; &nbsp;
                <FootOverlayBtn></FootOverlayBtn>
                <DesktopOverlayBtn></DesktopOverlayBtn>
              </div>
            </React.Fragment>
          )}
          <Drawer
            className="booking-drawer deal-drawer"
            placement="right"
            closable={false}
            destroyOnClose
            onClose={() => setVisible(false)}
            visible={visible}
          >
            <Header
              title={t("WEB.Book now")}
              onClick={() => setVisible(false)}
            />
            <Aside />
          </Drawer>
          {!info ? null : (
            <GetDeal
              dealId={dealId}
              restaurant_id={info.deal.restaurant.id}
              getDealVisible={getDealVisible}
              setGetDealVisible={setGetDealVisible}
              setRedeemVisible={setRedeemVisible}
              deal={info.deal}
              checkRedeem={checkRedeem}
            />
          )}
          {!info ? null : (
            <Redeem
              dealId={dealId}
              deal={info.deal}
              redeemVisible={redeemVisible}
              setRedeemVisible={setRedeemVisible}
              voucherAvailableList={voucherAvailableList}
              checkRedeem={checkRedeem}
            />
          )}
        </section>
        {canBuyVoucher &&
          isRedeemOnlyReservation && (
            <div className="page-deal-voucher">
              {renderGetDealButton()}
              <p></p>
              {private_token && renderRedeemButton()}
            </div>
          )}
        {!canBuyVoucher && isBookableReservation &&
          !isWalkInDeal && (
            <div className="pc-aside">
              <Aside />
            </div>
          )}
        {canWalkIn && (
          <WalkIn
            deal_id={info.deal.id}
            enable_pre_pay={enable_pre_pay}
            restaurant_id={info.deal.restaurant.id}
            visible={showWalkIn}
            setVisible={setShowWalkIn}
          ></WalkIn>
        )}
        <Locate />
      </div>
      <Footer hasMore={isMobile} />
    </div>
  );
};

export default Main;
